<script>
  import ActionButton from './ActionButton.svelte';
  import VolumeUp from '~icons/mdi/volume-high';
  import VolumeOff from '~icons/mdi/volume-off';
  import Close from '~icons/mdi/close';
  import SkipPrevious from '~icons/mdi/skip-previous';
  import SkipNext from '~icons/mdi/skip-next';
  import Play from '~icons/mdi/play';
  import Pause from '~icons/mdi/pause';
  import {
    toggleSoundtrack,
    musicPaused,
    playing,
    skipBack,
    skipForward,
    musicVolume,
    showPlayer,
    resume,
    pause,
  } from './AudioPlayer.svelte';
  import Spotify from '~/icons/Spotify.svelte';
  import Slider from '~/components/Slider.svelte';
</script>

<div
  class="container"
  style:background-image={playing.artUrl ? `url(${playing.artUrl})` : ''}
>
  {#if !showPlayer.current}
    <div class="soundtrack-button">
      <ActionButton onClick={toggleSoundtrack}>
        <VolumeUp size="1.5em" />
        Enable Soundtrack
      </ActionButton>
    </div>
  {:else}
    <div class="audio-container">
      <div class="header">
        <span class="mute">
          <ActionButton onClick={toggleSoundtrack}>
            <Close size="1.5em" />
          </ActionButton>
        </span>
        <div class="track-name"><span>{playing.track}</span></div>
        <ActionButton
          class="spotify"
          href="https://open.spotify.com/album/187hY3x9Hm3QsNKPXV0eZF?si=T7_BB9k2QvSmmvK20UzAXg"
        >
          <Spotify />
        </ActionButton>
      </div>
      <div class="music-controls">
        <ActionButton onClick={skipBack}>
          <SkipPrevious size="24px" />
        </ActionButton>
        {#if musicPaused.current}
          <ActionButton onClick={resume}>
            <Play size="24px" />
          </ActionButton>
        {:else}
          <ActionButton onClick={pause}>
            <Pause size="24px" />
          </ActionButton>
        {/if}
        <ActionButton onClick={skipForward}>
          <SkipNext size="24px" />
        </ActionButton>
      </div>
      <div class="volume">
        <VolumeUp size="1.25em" />
        <div class="slider-wrapper">
          <Slider min={0} max={1} step={0.1} value={musicVolume} />
        </div>
      </div>
    </div>
  {/if}
</div>

<style lang="scss">
  .container {
    border: 2px solid black;
    border-radius: 1em;
    background-size: cover;
    background-position: center center;
    display: grid;
    :global(html.dark-mode) & {
      border-color: white;
    }
  }
  .soundtrack-button {
    grid-row: 1/2;
    grid-column: 1/2;
    & :global(.action) {
      border: none;
      width: 100%;
    }
  }
  .audio-container {
    grid-row: 1/2;
    grid-column: 1/2;
  }
  .header {
    display: flex;
    justify-content: space-between;
    padding: 0.25rem;
    & :global(.action) {
      padding: 8px !important;
      border: none;
      background-color: #fff8 !important;
    }
  }
  :global(html.dark-mode .audio-container .action) {
    background-color: #0008 !important;
  }
  .volume {
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 1rem;
    padding-bottom: 0.5rem;
    padding-left: 1rem;
    .slider-wrapper {
      width: 75%;
    }
  }
  .track-name {
    color: black;
    padding: 0.5em;
    span {
      padding: 0.25em 0.5em;
      border-radius: 0.5em;
      background-color: #fff8 !important;
      :global(html.dark-mode) & {
        color: white;
        background-color: #0008 !important;
      }
    }
  }
  .music-controls {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 1em;
    padding: 0.5em;
    & :global(.action) {
      border: none;
      border-radius: 999px;
      background-color: #fff8 !important;
    }
  }
  :global(html.dark-mode .music-controls .action) {
    background-color: #0008 !important;
  }
</style>
